import React from "react";
import {Badge} from "reactstrap";
import {orderStatusLabel} from "../utils/orderStatus";

// Keyed by the status text the order API returns. Colors tell the story of an
// order: neutral while drafting, blue once agreed, amber while waiting for
// payment, green when settled, red/dark when it ended without being paid.
export const STATUS_STYLES = {
    Open: {color: "secondary"},
    Sent: {color: "info", dark: true},
    Confirmed: {color: "primary"},
    Done: {color: "warning", dark: true},
    Paid: {color: "success"},
    Canceled: {color: "danger"},
    Expired: {color: "dark"},
};

/** @param {{status: string}} props */
const OrderStatusBadge = ({status}) => {
    const {color, dark} = STATUS_STYLES[status] ?? {color: "secondary"};
    return (
        <Badge pill color={color} className={dark ? "text-dark" : undefined}>
            {orderStatusLabel(status)}
        </Badge>
    );
};

export default OrderStatusBadge;
